import React, { useState, useRef, useEffect } from "react";
import "./index.css"; // External CSS file\imp
import store from "store";
import { imageMediaUrl } from "../../util/config";
import { imagePrefixUrl } from "util/config";
import { Link } from "react-router-dom";

const TraineeCourses = () => {
  const [activeTab, setActiveTab] = useState("All");
  const [allTrainings, setAllTrainings] = useState([]);
  const [pendingTrainings, setPendingTrainings] = useState([]);
  const [inProgressTrainings, setInProgressTrainings] = useState([]);
  const [loading, setLoading] = useState(false);
  const tabs = ["Pending", "Completed", "All"];
  let userInfo = store.get("user");
  const formatDateToDDMM = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    return `${day}/${month}`;
  };

  const formatDuration = (seconds) => {
    const hrs = Math.floor(seconds / 3600)
      .toString()
      .padStart(2, "0");
    const mins = Math.floor((seconds % 3600) / 60)
      .toString()
      .padStart(2, "0");
    const secs = Math.floor(seconds % 60)
      .toString()
      .padStart(2, "0");
    return `${hrs}:${mins}:${secs}`;
  };
  const truncateWords = (text, wordLimit) => {
    if (!text) return "";
    const words = text.split(" ");
    if (words.length <= wordLimit) return text;
    return words.slice(0, wordLimit).join(" ") + "...";
  };

  const getOngoingTrainings = async (
    activeTab,
    setAllTrainings,
    setLoading,
    setPendingTrainings,
    setInProgressTrainings
  ) => {
    const apiUrl = process.env.REACT_APP_API_URL || "";
    const url = apiUrl + "api/trainee/courses";
    const accessToken = localStorage.getItem("accessToken");

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 seconds

    const fetchTab = async (status) => {
      const params = new URLSearchParams({
        completionStatus: encodeURIComponent(status),
        page: 0,
      });

      const res = await fetch(url + "?" + params.toString(), {
        method: "GET",
        headers: {
          Authorization: "Bearer " + accessToken,
        },
        signal: controller.signal,
      });

      if (!res.ok) {
        throw res;
      }

      const response = await res.json();
      return response.results.trainings || [];
    };

    try {
      let trainings = [];

      if (activeTab === "Pending") {
        const [pending, inProgress] = await Promise.all([
          fetchTab("Pending"),
          fetchTab("InProgress"),
        ]);

        setPendingTrainings(pending);
        setInProgressTrainings(inProgress);
        trainings = [...inProgress, ...pending]; // merge for combined view
      } else {
        const tabStatus =
          activeTab === "In Progress" ? "InProgress" : activeTab;
        trainings = await fetchTab(tabStatus);

        // Reset the others
        setPendingTrainings([]);
        setInProgressTrainings([]);
      }

      setAllTrainings(trainings);
    } catch (err) {
      if (err.name === "AbortError") {
        if (window.message && typeof window.message.error === "function") {
          window.message.error("Request timed out. Please try again later.");
        }
      } else if (err.status === 401) {
        if (window.message && typeof window.message.error === "function") {
          window.message.error(
            "Your session has been expired. Please relogin."
          );
        }
        localStorage.clear();
        window.location.reload();
      } else {
        if (window.message && typeof window.message.error === "function") {
          window.message.error("Some error has occurred.");
        }
      }
      console.error("Failed to fetch trainee trainings:", err);
    } finally {
      clearTimeout(timeoutId);
      setLoading(false);
    }
  };

  const renderTrainingButton = (item) => {
    const isPassed = item.successStatus === "passed";
    const isExpired =
      new Date(item.campaignId.expireAt) < new Date() && !isPassed;

    return (
      <>
        {!isExpired ? (
          <Link
            to={{
              pathname: isPassed
                ? "/trainee/result/" + item.campaignId._id
                : item.campaignId.disableRetry &&
                  item.successStatus === "failed"
                ? ""
                : "/trainee/course-intro/" + item.campaignId._id + "/Assigned",
              trainingInfoProps: item.campaignId.trainingId,
              campaignInfoProps: item,
            }}
            style={{
              pointerEvents:
                item.campaignId.disableRetry && item.successStatus === "failed"
                  ? "none"
                  : "auto",
            }}
          >
            <img
              style={{
                width: "35px",
                marginLeft: "10px",
                cursor: "pointer",
              }}
              src="/assets/Button.png"
              alt="button"
            />
          </Link>
        ) : (
          <img
            style={{
              width: "35px",
              marginLeft: "10px",
              opacity: 0.4,
              filter: "grayscale(100%)",
              cursor: "not-allowed",
            }}
            src="/assets/Button.png"
            alt="button"
          />
        )}
      </>
    );
  };

  const NoDataMessage = () => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        flex: 1,
      }}
    >
      <img
        src={"/assets/NoData.png"}
        alt=""
        style={{ objectFit: "contain", height: "50%", width: "50%" }}
      />
      <h3
        style={{
          textAlign: "center",
          color: "#8c8d8b",
          marginTop: "0px",
        }}
      >
        You have not completed any course yet.
      </h3>
    </div>
  );

  useEffect(() => {
    setLoading(true);
    getOngoingTrainings(
      activeTab,
      setAllTrainings,
      setLoading,
      setPendingTrainings,
      setInProgressTrainings
    );
  }, [activeTab]);
  console.log("All Trainings", allTrainings);
  return (
    <div>
      <div className="welcome-section">
        <h2 className="sub-title" style={{ paddingLeft: "8px" }}>
          My Courses
        </h2>
      </div>

      <div className="tabs">
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`tab-button ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>
      <div className="welcome-section" style={{ paddingLeft: "28px" }}>
        <h2 className="sub-title">
          {activeTab == "All"
            ? ""
            : activeTab == "Completed"
            ? "Your Completed Courses"
            : activeTab == "Pending"
            ? "In Progress Trainings"
            : "Continue where you left"}
        </h2>
      </div>

      <div className="tab-content">
        {loading ? (
          <div>
            <div className="shimmer-row" style={{ margin: "3px" }}>
              <div className="shimmer-card">
                <div className="shimmer"></div>
              </div>
              <div className="shimmer-card">
                <div className="shimmer"></div>
              </div>
              <div className="shimmer-card">
                <div className="shimmer"></div>
              </div>
              <div className="shimmer-card">
                <div className="shimmer"></div>
              </div>
            </div>
            <div className="shimmer-row" style={{ margin: "3px" }}>
              <div className="shimmer-card">
                <div className="shimmer"></div>
              </div>
              <div className="shimmer-card">
                <div className="shimmer"></div>
              </div>
              <div className="shimmer-card">
                <div className="shimmer"></div>
              </div>
              <div className="shimmer-card">
                <div className="shimmer"></div>
              </div>
            </div>
            <div className="shimmer-row" style={{ margin: "3px" }}>
              <div className="shimmer-card">
                <div className="shimmer"></div>
              </div>
              <div className="shimmer-card">
                <div className="shimmer"></div>
              </div>
              <div className="shimmer-card">
                <div className="shimmer"></div>
              </div>
              <div className="shimmer-card">
                <div className="shimmer"></div>
              </div>
            </div>
          </div>
        ) : (
          <div className="learning-cards" style={{ padding: "12px" }}>
            {activeTab === "Pending" ? (
              <div className="learning-cards" style={{ padding: "12px" }}>
                {inProgressTrainings.length > 0 && (
                  <>
                    {inProgressTrainings.map((item, index) => {
                      const isExpiredAndNotPassed =
                        new Date(item.campaignId.expireAt) < new Date() &&
                        item.successStatus !== "passed";
                      return (
                        <div
                          className="learning-card learning-card-wrapper"
                          key={`inProgress-${index}`}
                        >
                          <div className="image-wrapper">
                            <img
                              className="imageCard"
                              src={
                                item.campaignId.trainingId.coverImage
                                  ? `${imagePrefixUrl}${item.campaignId.trainingId.coverImage}`
                                  : require("assets/images/courses/cover_image.jpg")
                              }
                            />
                            {isExpiredAndNotPassed && (
                              <div className="card-overlay">
                                <span className="overlay-text">
                                  Training Over!!
                                </span>
                              </div>
                            )}
                          </div>

                          <span
                            style={{
                              paddingLeft: "10px",
                              color: "#575857",
                              fontSize: "15px",
                            }}
                          >
                            {item.campaignId.trainingId.totalDuration
                              ? formatDuration(
                                  item.campaignId.trainingId.totalDuration || 0
                                )
                              : "__:__:__"}
                          </span>
                          <h5>{item.campaignId.trainingId.name || " "}</h5>
                          <p>
                            {truncateWords(
                              item.campaignId.trainingId.shortDescription,
                              15
                            )}
                          </p>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              padding: "0 10px",
                            }}
                          >
                            <div>
                              <span
                                style={{
                                  display: "block",
                                  color: "#575857",
                                  fontSize: "13px",
                                }}
                              >
                                Assigned on{" "}
                                {formatDateToDDMM(item.campaignId.createdAt)}
                              </span>
                              <span
                                style={{
                                  display: "block",
                                  color: "#575857",
                                  fontSize: "13px",
                                }}
                              >
                                {item.successStatus === "passed"
                                  ? "Completed"
                                  : "Complete by "}
                                {item.successStatus === "passed"
                                  ? ""
                                  : formatDateToDDMM(item.campaignId.expireAt)}
                              </span>
                            </div>

                            {renderTrainingButton(item)}
                          </div>
                        </div>
                      );
                    })}
                  </>
                )}

                {pendingTrainings.length > 0 && (
                  <>
                    <div style={{ width: "100%", margin: "24px 0 12px" }}>
                      <h2 className="sub-title">Pending Trainings</h2>
                    </div>
                    {pendingTrainings.map((item, index) => {
                      const isExpiredAndNotPassed =
                        new Date(item.campaignId.expireAt) < new Date() &&
                        item.successStatus !== "passed";
                      return (
                        <div
                          className="learning-card learning-card-wrapper"
                          key={`inProgress-${index}`}
                        >
                          <div className="image-wrapper">
                            <img
                              className="imageCard"
                              src={
                                item.campaignId.trainingId.coverImage
                                  ? `${imagePrefixUrl}${item.campaignId.trainingId.coverImage}`
                                  : require("assets/images/courses/cover_image.jpg")
                              }
                            />
                            {isExpiredAndNotPassed && (
                              <div className="card-overlay">
                                <span className="overlay-text">
                                  Training Over!!
                                </span>
                              </div>
                            )}
                          </div>

                          <span
                            style={{
                              paddingLeft: "10px",
                              color: "#575857",
                              fontSize: "15px",
                            }}
                          >
                            {item.campaignId.trainingId.totalDuration
                              ? formatDuration(
                                  item.campaignId.trainingId.totalDuration || 0
                                )
                              : "__:__:__"}
                          </span>
                          <h5>{item.campaignId.trainingId.name || " "}</h5>
                          <p>
                            {truncateWords(
                              item.campaignId.trainingId.shortDescription,
                              15
                            )}
                          </p>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              padding: "0 10px",
                            }}
                          >
                            <div>
                              <span
                                style={{
                                  display: "block",
                                  color: "#575857",
                                  fontSize: "13px",
                                }}
                              >
                                Assigned on{" "}
                                {formatDateToDDMM(item.campaignId.createdAt)}
                              </span>
                              <span
                                style={{
                                  display: "block",
                                  color: "#575857",
                                  fontSize: "13px",
                                }}
                              >
                                {item.successStatus === "passed"
                                  ? "Completed"
                                  : "Complete by "}
                                {item.successStatus === "passed"
                                  ? ""
                                  : formatDateToDDMM(item.campaignId.expireAt)}
                              </span>
                            </div>

                            {renderTrainingButton(item)}
                          </div>
                        </div>
                      );
                    })}
                  </>
                )}

                {inProgressTrainings.length === 0 &&
                  pendingTrainings.length === 0 && <NoDataMessage />}
              </div>
            ) : allTrainings.length > 0 ? (
              allTrainings.map((item, index) => {
                const isExpiredAndNotPassed =
                  new Date(item.campaignId.expireAt) < new Date() &&
                  item.successStatus !== "passed";
                return (
                  <div
                    className="learning-card learning-card-wrapper"
                    key={`inProgress-${index}`}
                  >
                    <div className="image-wrapper">
                      <img
                        className="imageCard"
                        src={
                          item.campaignId.trainingId.coverImage
                            ? `${imagePrefixUrl}${item.campaignId.trainingId.coverImage}`
                            : require("assets/images/courses/cover_image.jpg")
                        }
                      />
                      {isExpiredAndNotPassed && (
                        <div className="card-overlay">
                          <span className="overlay-text">Training Over!!</span>
                        </div>
                      )}
                    </div>

                    <span
                      style={{
                        paddingLeft: "10px",
                        color: "#575857",
                        fontSize: "15px",
                      }}
                    >
                      {item.campaignId.trainingId.totalDuration
                        ? formatDuration(
                            item.campaignId.trainingId.totalDuration || 0
                          )
                        : "__:__:__"}
                    </span>
                    <h5>{item.campaignId.trainingId.name || " "}</h5>
                    <p>
                      {truncateWords(
                        item.campaignId.trainingId.shortDescription,
                        15
                      )}
                    </p>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "0 10px",
                      }}
                    >
                      <div>
                        <span
                          style={{
                            display: "block",
                            color: "#575857",
                            fontSize: "13px",
                          }}
                        >
                          Assigned on{" "}
                          {formatDateToDDMM(item.campaignId.createdAt)}
                        </span>
                        <span
                          style={{
                            display: "block",
                            color: "#575857",
                            fontSize: "13px",
                          }}
                        >
                          {item.successStatus === "passed"
                            ? "Completed"
                            : "Complete by "}
                          {item.successStatus === "passed"
                            ? ""
                            : formatDateToDDMM(item.campaignId.expireAt)}
                        </span>
                      </div>

                      {renderTrainingButton(item)}
                    </div>
                  </div>
                );
              })
            ) : (
              <NoDataMessage />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TraineeCourses;
